import { ButtonSave, Button } from "components/buttons";
import { FormSelect } from "components/form-fields";
import { Modal, ModalSize } from "components/notifications";
import PropTypes from "prop-types";
import React, { useState } from "react";
import './Hierarchy.css';

export function HierarchyAddQuestionModal({ isOpen = false, questionTypes, onCancel, onSave }) {

    const [addedQuestionType, setAddedQuestionType] = useState(null);

    const handleClose = () => {
        setAddedQuestionType(null);
        onCancel();
    }

    const handleSave = () => {
        onSave(addedQuestionType);
        handleClose();
    }

    return (
        <Modal
            isOpen={isOpen}
            title="Add Question"
            isCloseButtonShown={false}
            clickOutsideClose={false}
            size={ModalSize.SMALL}
            onClose={handleClose}
        >
            <>
                <FormSelect
                    items={questionTypes.map(m => { return { id: m.key, name: m.name } })}
                    placeholder="Please select"
                    headingText="Please select a question type:"
                    onItemSelect={(e) => setAddedQuestionType(e.id)}
                    selectedValue={addedQuestionType}
                ></FormSelect>
                <div className="bp6-dialog-footer">

                    <div className="bp6-dialog-footer-actions">
                        <Button
                            text="Cancel"
                            intent="none"
                            onClick={handleClose}
                        ></Button>
                        <ButtonSave
                            id="add-question-type"
                            onClick={handleSave}
                            simpleDisabled={!addedQuestionType}
                            text={'Add Question'}
                        ></ButtonSave>
                    </div>
                </div>
            </>
        </Modal>
    )
}

HierarchyAddQuestionModal.propTypes = {
    isOpen: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    questionTypes: PropTypes.array.isRequired,
}